import { FrequencyControl } from 'src/app/models';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { OperationPointRequest, OutputInfo, SelectedPump, SelectedUnits } from '../models';
import { map } from 'rxjs/operators';
import { ViscosityControl } from '../models/viscosity-control.model';

@Injectable({
  providedIn: 'root',
})
export class PdfGenerationService {
  constructor(private http: HttpClient) {}

  public generatePDF(
    operationPoints: OperationPointRequest[],
    selectedPump: SelectedPump,
    selectedUnits: SelectedUnits,
    frequencyControl: FrequencyControl,
    viscosityControl: ViscosityControl,
    startingTorqueRatedTorque: number,
    outputInfo: OutputInfo,
    visibleRows: string[]
  ) {
    const frequencyControlActive =
      frequencyControl.active && frequencyControl.selectedGearI !== null && frequencyControl.selectedGearI > 0;

    const viscosityControlActive =
      viscosityControl.active && viscosityControl.viscosity != null && viscosityControl.viscosity !== 0;

    // Replace newlines with html equivalent
    outputInfo.notes = outputInfo.notes.replace(/\r\n|\r|\n/g, '<br />');

    const request = {
      units: {
        systemId: selectedUnits.unitSystem?.id,
        capacityUnitId: selectedUnits.capacity?.id,
        pressureUnitId: selectedUnits.pressure?.id,
      },
      pump: {
        range: selectedPump.range,
        size: selectedPump.size,
        pressureStage: selectedPump.pressureStage,
        maxDifferentialPressure: selectedPump.maxDifferentialPressure,
        baseSize: selectedPump.baseSize,
        rotor: selectedPump.rotor,
        rotation: selectedPump.rotation,
      },
      operationPoints: operationPoints,
      frequencyControl: frequencyControlActive ? frequencyControl : { active: false },
      viscosityControl: viscosityControlActive ? viscosityControl : { active: false },
      startingTorqueRatedTorque: startingTorqueRatedTorque,
      customerReference: outputInfo,
      visibleRows: visibleRows,
    };
    const generatePdfUrl = `${environment.calculationApi}/v1/output`;

    return this.http
      .post(generatePdfUrl, request, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(map((res: HttpResponse<Blob>) => res.body));
  }
}
